import { render } from "./AddBrandModal.vue?vue&type=template&id=12d895e4&ts=true"
import script from "./AddBrandModal.vue?vue&type=script&lang=ts"
export * from "./AddBrandModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-pim-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__